import { createSelector } from '@ngxs/store';

import { QualtricsSurvey, QualtricsSurveyDefinition } from '../../models';
import {
  QualtricsSurveyEntry,
  QualtricsSurveyFeedbackState,
  QualtricsSurveyFeedbackStateModel,
} from '../qualtrics-survey-feedback.state';

export class QualtricsFeedbackSelectors {
  static submitFeedbackError(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (state: QualtricsSurveyFeedbackStateModel): boolean =>
        Boolean(state.surveys[surveyType]?.submitError),
    );
  }

  static submitFeedbackValidationError(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (state: QualtricsSurveyFeedbackStateModel): boolean =>
        Boolean(state.surveys[surveyType]?.submitValidationError),
    );
  }

  static submitFeedbackSuccess(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (state: QualtricsSurveyFeedbackStateModel): boolean =>
        Boolean(state.surveys[surveyType]?.submitSuccess),
    );
  }

  static surveyEntryFor(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (
        state: QualtricsSurveyFeedbackStateModel,
      ): QualtricsSurveyEntry | undefined => state.surveys[surveyType],
    );
  }

  static surveyDefinitionFor(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (
        state: QualtricsSurveyFeedbackStateModel,
      ): QualtricsSurveyDefinition | null =>
        state.surveys[surveyType]?.surveyDefinition ?? null,
    );
  }

  static surveyFor(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (state: QualtricsSurveyFeedbackStateModel): QualtricsSurvey | null =>
        state.surveys[surveyType]?.survey ?? null,
    );
  }

  static loadErrorFor(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (state: QualtricsSurveyFeedbackStateModel): string =>
        state.surveys[surveyType]?.error ?? '',
    );
  }

  static isFeedbackEnabledFor(surveyType: string) {
    return createSelector(
      [QualtricsSurveyFeedbackState],
      (state: QualtricsSurveyFeedbackStateModel): boolean => {
        const entry = state.surveys[surveyType];

        return (
          Boolean(entry?.surveyDefinition?.elements?.length) && !entry?.error
        );
      },
    );
  }
}
